import { ToggleButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MiscSavio, StyleguideSavioColors } from "../../../configuration/themeSettings";



export const ToggleButtonPartialShipmentStyled = styled(ToggleButton)(({ theme }) => ({
        "&.Mui-selected": {
            backgroundColor: MiscSavio.hoverColor,
            color: "white",
            "&:hover": {
                color: "white",
                backgroundColor: MiscSavio.hoverColor,
            },
        },
        "&": {
            backgroundColor: StyleguideSavioColors.lightGrey,
            color: "black",
            "&:hover": {
                color: "white",
                backgroundColor: StyleguideSavioColors.lightBlue,
            },
        },
        "&:first-of-type": {
            borderTopLeftRadius: "12px",
            borderBottomLeftRadius: "12px",
        },
        "&:last-of-type": {
            borderTopRightRadius: "12px",
            borderBottomRightRadius: "12px",
        },
        
        width: "30px",
        padding:"5px",
        fontSize:"12px",
        marginBottom:"10px"
}));
